module.exports = __webpack_public_path__ + "static/media/fr_add_to_google_wallet.2b123f26.svg";